import React, {Component} from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';

import LoginIcon from '@material-ui/icons/ExitToApp';

import { withStyles} from '@material-ui/core/styles';

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
    },
});

class EmailLoginForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: ''
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }


    handleInputChange(event) {
        const target = event.target;

        this.setState({
            email: target.value
        });
    }

    handleKeyDown(event) {
        if (event.key === 'Enter') {
            this.handleClick();
        }
    }

    handleClick() {
        const urlParams = new URLSearchParams(window.location.search);
        const eventId = urlParams.get('event_id');
        window.top.location = window.location.origin + '/index.php?p=remote&op=quickenter&event_id='+eventId+'&member-email='+this.state.email;
    }

    render() {
        const { classes } = this.props;

        return (
            <Box>
                <FormControl fullWidth className={classes.margin}>
                    <InputLabel htmlFor="member-e-mail">E-MAIL:</InputLabel>
                    <Input
                        id="member-e-mail"
                        label="e-mail"
                        onChange={this.handleInputChange}
                        onKeyDown={this.handleKeyDown}
                    />
                </FormControl>
                <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    endIcon={<LoginIcon />}
                    onClick={this.handleClick}
                >
                    {this.props.buttonText}
                </Button>
            </Box>
        );
    }
}

export default withStyles(styles)(EmailLoginForm);
